export default __webpack_public_path__ + "static/media/716.8c08f633.png";